import { render, staticRenderFns } from "./TreeNew.vue?vue&type=template&id=5839a356&scoped=true&"
import script from "./TreeNew.vue?vue&type=script&lang=ts&"
export * from "./TreeNew.vue?vue&type=script&lang=ts&"
import style0 from "./TreeNew.vue?vue&type=style&index=0&id=5839a356&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5839a356",
  null
  
)

export default component.exports